<template>
    <b-button
        v-b-tooltip.hover
        class="print-button"
        size="lg"
        variant="icon"
        :title="$translate('print')"
        @click="openPrintPreview"
    >
        <router-link
            :to="{
                name: ROUTES.PRINT_WELL,
                params: $route.params
            }"
            target="_blank"
        >
            <print-icon />
        </router-link>
    </b-button>
</template>

<script>
import { ROUTES } from '../../../business/const'
import PrintIcon from './icons/PrinterIcon'

export default {
    name: 'PrintButton',
    components: { PrintIcon },
    data: () => ({
        ROUTES
    }),
    methods: {
        openPrintPreview() {
            this.$log.actionEvent('print')
            console.log('openPrintPreview')
        }
    }
}
</script>

<style lang="scss">
a {
    color: $light-3;
    text-decoration: none;
}
</style>
